import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { Button } from '@/components/ui/button';
import { Home, ArrowRight } from 'lucide-react';

export default function NotFoundPage() {
  const { lang } = useLanguage();
  const isAr = lang === 'ar';
  const displayFont = isAr ? 'var(--font-ar-display)' : 'var(--font-en-display)';

  return (
    <div data-testid="not-found-page" className="min-h-screen bg-gradient-to-br from-[#0B2F44] to-[#071E2C] flex items-center justify-center px-6">
      <div className="text-center max-w-lg">
        <div className="text-[120px] lg:text-[180px] font-black text-[#C9A84C]/20 leading-none" style={{ fontFamily: 'var(--font-en-mono)' }}>
          404
        </div>
        <h1 className="text-2xl lg:text-3xl font-bold text-white -mt-6 mb-4" style={{ fontFamily: displayFont }}>
          {isAr ? 'الصفحة غير موجودة' : 'Page Not Found'}
        </h1>
        <p className="text-white/50 text-base mb-8">
          {isAr
            ? 'عذراً، الصفحة التي تبحث عنها غير موجودة أو تم نقلها.'
            : "Sorry, the page you're looking for doesn't exist or has been moved."}
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/">
            <Button className="bg-[#C9A84C] hover:bg-[#A68966] text-[#0B2F44] font-bold px-8 py-6 group">
              <Home className="w-5 h-5 me-2" />
              {isAr ? 'العودة للرئيسية' : 'Back to Home'}
            </Button>
          </Link>
          <Link to="/contact">
            <Button variant="outline" className="border-white/30 text-white hover:bg-white/10 font-semibold px-8 py-6">
              {isAr ? 'تواصل معنا' : 'Contact Us'}
              <ArrowRight className="w-5 h-5 ms-2" />
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
